import { useEffect, useState } from "react";

import '../../../../styles/stepper.css'
import ImageCapture from "../../../../components/ImageCapture";
import PDFViewer from "../../../../components/PDFViewer";
import PDFUploader from "../../../../pages/PDFUploader";
import PDFImageViewer from "../../../../components/PDF_ImageViewer";
import DatePicker from "react-datepicker";
import PDFImageViewer2 from "../../../../components/PDFImageViewer2";



const Page2 = ({ formData, setFormData, nextPage, prevPage }) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    
    if (!formData.governmentId) newErrors.governmentId = "You must upload Government ID for it is required.";

    if (!formData.scannedImages) newErrors.scannedImages = "Documents are required.";

    if (!formData.idType) newErrors.idType         = "Type of ID is required.";
    if (!formData.idNo) newErrors.idNo             = "ID No is required.";
    if (!formData.dateIssued) newErrors.dateIssued = "Date Issued is required.";

    
    if (!formData.principalImage) newErrors.principalImage = "Principal's image is required.";
    if (!formData.principalImageSignature) newErrors.principalImageSignature = "Principal's Signature is required.";

    if (formData.secondPartyIdType) {
      if (!formData.secondPartyGovernmentId) newErrors.secondPartyGovernmentId= "You must upload a government-issued ID that matches the type you selected.";
      if (!formData.secondPartyIdNo) newErrors.secondPartyIdNo             = "ID No is required.";
      if (!formData.secondPartyDateIssued) newErrors.secondPartyDateIssued = "Date Issued is required.";


      if (!formData.secondPartyPrincipalImage) newErrors.secondPartyPrincipalImage = "(Second Party)Principal's image is required.";
      if (!formData.secondPartyPrincipalImageSignature) newErrors.secondPartyPrincipalImageSignature = "(Second Party)Principal's Signature is required.";
    }
   
    
    if (formData.witnessFirstFullname) {
      if (!formData.witnessFirstPhoto) newErrors.witnessFirstPhoto = "1st Witness' image is required.";
      if (!formData.witnessFirstPhotoSignature) newErrors.witnessFirstPhotoSignature = "1st Witness' Signature is required.";
    }

    if (formData.witnessSecondFullname) {
      if (!formData.witnessSecondPhoto) newErrors.witnessSecondPhoto = "2nd Witness' image is required.";
      if (!formData.witnessSecondPhotoSignature) newErrors.witnessSecondPhotoSignature = "2nd Witness' Signature is required.";
    }



    setErrors(newErrors);

    // Scroll to the first invalid element
    setTimeout(() => {
    const firstInvalidElement = document.querySelector('.invalid-feedback');
      if (firstInvalidElement) {
        firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalidElement.focus?.();
      }
    }, 0);


    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validate()) {
      nextPage();
    }
  };
 
  

  const handleImageChange = (image,keyName) => {
      setFormData({ ...formData, [keyName]: image });
  };



  const handlePDFImageChange = (image, keyName, action="add",type="image") => {

    if(type==="image"){
      if(action==="add"){
        setFormData(prevData => {
          const updatedImages = Array.isArray(prevData[keyName])
            ? [...prevData[keyName], image] // Add new image to array if it exists
            : [image]; // If no images exist yet, create an array with the new image
          return {
            ...prevData,
            [keyName]: updatedImages, // Update the scannedImages with the new array
          };
        });
      }
      else if(action==="delete"){
        setFormData(prevData => {
          return {
            ...prevData,
            [keyName]: image, // Update the scannedImages with the new array
          };
        });
      }
      else if(action==="recapture"){
        setFormData(prevData => {
          return {
            ...prevData,
            [keyName]: image, // Update the scannedImages with the new array
          };
        });
      }
    }
    else if(type==="pdf"){
      setFormData(prevData => {
        return {
          ...prevData,
          [keyName]: image, // Update the scannedImages with the new array
        };
      });
    }

    
};

  const [cameras, setCameras] = useState([]);

  useEffect(() => {
    // Function to fetch available cameras
    const fetchCameras = async () => {
      try {
        // Get all devices
        const devices = await navigator.mediaDevices.enumerateDevices();
        
        // Filter video input devices (cameras)
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        
        // Set the video devices into state
        setCameras(videoDevices);
      } catch (err) {
        console.error('Error fetching devices: ', err);
      }
    };

    // Call the function to fetch cameras
    fetchCameras();
  }, []);


  useEffect(() => {
    console.log(formData);
  }, [formData]);


  const handleDateChange = (date,key) => {
    setFormData({
      ...formData,
      [key]: date ? date : "",
    });
  };

  return (
    <div className="step-content row">

      <div className="d-none">
        <h3>Available Cameras:</h3>
        {cameras.length > 0 ? (
          <ul>
            {cameras.map((camera, index) => (
              <li key={index}>
                {camera.label || `Camera ${index + 1}`} - {camera.deviceId}
              </li>
            ))}
          </ul>
        ) : (
          <p>No cameras found.</p>
        )}
      </div>

      {/* 1st Party */}
      <div className="col-lg-12">
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-2">
          <div className="me-1">
            <h5 className="mb-1">1st Party Requirements</h5>
            <p className="mb-1"><span className="fw-medium">Upload requirements.</span></p>
          </div>
          <div className="d-flex align-items-center  d-none">
            <span className="badge bg-label-danger">UI/UX</span>
            <i className="bx bx-share-alt bx-sm mx-4" />
            <i className="bx bx-bookmarks bx-sm" />
          </div>
        </div>

        <div className="row g-4">


          <div className="col-md-6">
            <div className="card shadow-none border">
              <ImageCapture btnCameraTitle="Open Scanner" title="Government Valid ID" subtitle="Upload / Scan valid ID" onImageChange={handleImageChange} keyName="governmentId" preLoadedImage={formData.governmentId} useSignaturePad={false} info={"Upload or scan valid id"} />

              <div className="row p-4 pt-1">
              {!formData.governmentId && errors.governmentId && <div className="invalid-feedback d-block blink">{errors.governmentId}</div>}

                <div className="col-md-4 ps-lg-3 pe-lg-0">
                  <label className="form-label mb-1 fw-bold" htmlFor="sel_id_type" >
                    Type of ID
                  </label>

                  <select
                    id="sel_id_type"
                    className={`select2 form-select ${!formData.idType && errors.idType && 'is-invalid'}`}
                    data-placeholder="Select ID"
                    value={formData.idType}
                    name="attachment_id_type"
                    onChange={(e) => setFormData({ ...formData, idType: e.target.value })}
                  >
                    <option value="">Select Type of ID</option>
                    <option value="Barangay ID">Barangay ID</option>
                    <option value="Diplomatic ID">Diplomatic ID</option>
                    <option value="Driver's License">Driver's License</option>
                    <option value="Firearms License">Firearms License</option>
                    <option value="GSIS ID">GSIS ID</option>
                    <option value="Marriage Certificate">Marriage Certificate</option>
                    <option value="NBI Clearance">NBI Clearance</option>
                    <option value="OFW ID">OFW ID</option>
                    <option value="Overseas Employment Certificate (OEC)">Overseas Employment Certificate (OEC)</option>
                    <option value="Passport">Passport</option>
                    <option value="PhilHealth ID">PhilHealth ID</option>
                    <option value="Philippine Identification (PhilID)">Philippine Identification (PhilID)</option>
                    <option value="Police Clearance">Police Clearance</option>
                    <option value="PRC ID">PRC ID</option>
                    <option value="Seaman's Book">Seaman's Book</option>
                    <option value="Senior Citizen ID">Senior Citizen ID</option>
                    <option value="SSS ID">SSS ID</option>
                    <option value="TIN ID">TIN ID</option>
                    <option value="UMID Card">UMID Card</option>
                    <option value="Voter's ID">Voter's ID</option>


                  </select>
                  {!formData.idType && errors.idType && <div className="invalid-feedback d-block blink">{errors.idType}</div>}


                </div>

                <div className="col-md-4 ps-lg-1 pe-lg-0">
                  <label className="form-label fw-bold" htmlFor="txtIDNo" >
                    ID Number
                  </label>
                  <input
                    type="text"
                    className={`form-control mt-n1 ${!formData.idNo && errors.idNo && 'is-invalid'}`}
                    id="txtIDNo"
                    value={formData.idNo}
                    name="attachment_id_number"
                    placeholder="Enter Valid ID No"
                    aria-label="idNo"
                    onChange={(e) => setFormData({ ...formData, idNo: e.target.value })}
                  />
                  {!formData.idNo && errors.idNo && <div className="invalid-feedback d-block blink">{errors.idNo}</div>}
                </div>

                <div className="col-md-4 ps-lg-1 pe-lg-3">
                  <label className="form-label mb-1  fw-bold" htmlFor="txtDateIssued" >
                    Date Issued
                  </label>
                  <DatePicker
                    id="txtDateIssued"
                    name="date_issued"
                    className={`form-control flatpickr-input active w-100  ${!formData.dateIssued && errors.dateIssued && 'is-invalid'}`}
                    placeholderText="YYYY-MM-DD"

                    selected={formData.dateIssued}
                    onChange={(date)=>handleDateChange(date,"dateIssued")}

                    dateFormat="yyyy-MM-dd"
                  />

                  {!formData.dateIssued && errors.dateIssued && <div className="invalid-feedback d-block blink">{errors.dateIssued}</div>}
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-6">
            <div className="card shadow-none border">
              <ImageCapture btnCameraTitle="Open Camera" title="Principal" subtitle="Take a photo of a Principal" onImageChange={handleImageChange} keyName="principalImage" preLoadedImage={formData.principalImage} useSignaturePad={true} preLoadedSignature={formData.principalImageSignature} hasUploadButton={false} hasRemoveButton={true} info={"Open camera to capture 1st Party"} />
              {!formData.principalImage && errors.principalImage && <div className="invalid-feedback d-block blink ms-4">{errors.principalImage}</div>}
              {!formData.principalImageSignature && errors.principalImageSignature && <div className="invalid-feedback d-block blink ms-4 mb-4">{errors.principalImageSignature}</div>}
            </div>
          </div>
        </div>
      </div>
      {/* End 1st Party */}


      <hr className="my-4 px-0" />

      {/* 2nd Party */}
      <div className="col-lg-12">
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-2">
          <div className="me-1">
            <h5 className="mb-1">2nd Party Requirements</h5>
            <p className="mb-1"><span className="fw-medium">Upload requirements.</span></p>
          </div>
          <div className="d-flex align-items-center  d-none">
            <span className="badge bg-label-danger">UI/UX</span>
            <i className="bx bx-share-alt bx-sm mx-4" />
            <i className="bx bx-bookmarks bx-sm" />
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="card shadow-none border">
              <ImageCapture btnCameraTitle="Open Scanner" title="Government Valid ID" subtitle="Upload / Scan valid ID" onImageChange={handleImageChange} keyName="secondPartyGovernmentId" preLoadedImage={formData.secondPartyGovernmentId} useSignaturePad={false} info={"Upload or scan valid id"} />

              <div className="row p-4 pt-1">
                {!formData.secondPartyGovernmentId && errors.secondPartyGovernmentId && <div className="invalid-feedback d-block blink">{errors.secondPartyGovernmentId}</div>}
                <div className="col-md-4 ps-lg-3 pe-lg-0">
                  <label className="form-label mb-1 fw-bold" htmlFor="sel_id_type" >
                    Type of ID
                  </label>

                  <select
                    id="sel_id_type"
                    className={`select2 form-select ${!formData.secondPartyIdType && errors.secondPartyIdType && 'is-invalid'}`}
                    data-placeholder="Select ID"
                    value={formData.secondPartyIdType}
                    name="second_party_attachment_id_type"
                    onChange={(e) => setFormData({ ...formData, secondPartyIdType: e.target.value })}
                  >
                    <option value="">Select Type of ID</option>
                    <option value="Barangay ID">Barangay ID</option>
                    <option value="Diplomatic ID">Diplomatic ID</option>
                    <option value="Driver's License">Driver's License</option>
                    <option value="Firearms License">Firearms License</option>
                    <option value="GSIS ID">GSIS ID</option>
                    <option value="Marriage Certificate">Marriage Certificate</option>
                    <option value="NBI Clearance">NBI Clearance</option>
                    <option value="OFW ID">OFW ID</option>
                    <option value="Overseas Employment Certificate (OEC)">Overseas Employment Certificate (OEC)</option>
                    <option value="Passport">Passport</option>
                    <option value="PhilHealth ID">PhilHealth ID</option>
                    <option value="Philippine Identification (PhilID)">Philippine Identification (PhilID)</option>
                    <option value="Police Clearance">Police Clearance</option>
                    <option value="PRC ID">PRC ID</option>
                    <option value="Seaman's Book">Seaman's Book</option>
                    <option value="Senior Citizen ID">Senior Citizen ID</option>
                    <option value="SSS ID">SSS ID</option>
                    <option value="TIN ID">TIN ID</option>
                    <option value="UMID Card">UMID Card</option>
                    <option value="Voter's ID">Voter's ID</option>


                  </select>
                  {!formData.secondPartyIdType && errors.secondPartyIdType && <div className="invalid-feedback d-block blink">{errors.secondPartyIdType}</div>}
                </div>

                <div className="col-md-4 ps-lg-1 pe-lg-0">
                  <label className="form-label fw-bold" htmlFor="secondPartyTxtIDNo" >
                    ID Number
                  </label>
                  <input
                    type="text"
                    className={`form-control mt-n1 ${!formData.secondPartyIdNo && errors.secondPartyIdNo && 'is-invalid'}`}
                    id="secondPartyTxtIDNo"
                    value={formData.secondPartyIdNo}
                    name="attachment_id_number"
                    placeholder="Enter Valid ID No"
                    aria-label="secondPartyIdNo"
                    onChange={(e) => setFormData({ ...formData, secondPartyIdNo: e.target.value })}
                  />
                  {!formData.secondPartyIdNo && errors.secondPartyIdNo && <div className="invalid-feedback d-block blink">{errors.secondPartyIdNo}</div>}
                </div>

                <div className="col-md-4 ps-lg-1 pe-lg-3">
                  <label className="form-label mb-1  fw-bold" htmlFor="secondPartyTxtDateIssued" >
                    Date Issued
                  </label>
                  <DatePicker
                    id="secondPartyTxtDateIssued"
                    name="second_party_date_issued"
                    className={`form-control flatpickr-input active w-100  ${!formData.secondPartyDateIssued && errors.secondPartyDateIssued && 'is-invalid'}`}
                    placeholderText="YYYY-MM-DD"

                    selected={formData.secondPartyDateIssued}
                    onChange={(date)=>handleDateChange(date,"secondPartyDateIssued")}


                    dateFormat="yyyy-MM-dd"
                  />

                  {!formData.secondPartyDateIssued && errors.secondPartyDateIssued && <div className="invalid-feedback d-block blink">{errors.secondPartyDateIssued}</div>}
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-6">
            <div className="card shadow-none border">
              <ImageCapture btnCameraTitle="Open Camera" title="2nd Party" subtitle="Take a photo of a Principal" onImageChange={handleImageChange} keyName="secondPartyPrincipalImage" preLoadedImage={formData.secondPartyPrincipalImage} useSignaturePad={true} preLoadedSignature={formData.secondPartyPrincipalImageSignature} hasUploadButton={false} hasRemoveButton={true} info={"Open camera to capture 2nd Party"} />
              {!formData.secondPartyPrincipalImage && errors.secondPartyPrincipalImage && <div className="invalid-feedback d-block blink ms-4">{errors.secondPartyPrincipalImage}</div>}
              {!formData.secondPartyPrincipalImageSignature && errors.secondPartyPrincipalImageSignature && <div className="invalid-feedback d-block blink ms-4 mb-4">{errors.secondPartyPrincipalImageSignature}</div>}
            </div>
          </div>
        </div>
      </div>
      {/* End 2nd Party */}





      <hr className="my-4 px-0" />


      
      <PDFImageViewer2 btnCameraTitle="Scan Documents" title="Documents" subtitle="Scan notarial documents" onImageChange={handlePDFImageChange} keyName="scannedImages" preLoadedImage={formData.scannedImages} />
      {!formData.scannedImages && errors.scannedImages && <div className="invalid-feedback d-block blink">{errors.scannedImages}</div>}
  

      <hr className="my-4 px-0" />

 

      <div className="me-1">
          <h5 className="mb-1">Witness(es)</h5>
          <p className="mb-1"><span className="fw-medium">Take a witness's photo.</span></p>
        </div>
      <div className="col-12">
        <div className="row mb-4">
          <div className="col-md-6">
            <div className="card shadow-none border">
              <ImageCapture btnCameraTitle="Open Camera" title="1st Witness" subtitle="Take a photo of Witness" onImageChange={handleImageChange} keyName="witnessFirstPhoto" preLoadedImage={formData.witnessFirstPhoto} useSignaturePad={true} preLoadedSignature={formData.witnessFirstPhotoSignature} hasUploadButton={false} hasRemoveButton={true} info={"Capture witness and add signature below"} />
              <div className="p-4 pt-0 mt-n2">
              {!formData.witnessFirstPhoto && errors.witnessFirstPhoto && <div className="invalid-feedback d-block blink ">{errors.witnessFirstPhoto}</div>}
              {!formData.witnessFirstPhotoSignature && errors.witnessFirstPhotoSignature && <div className="invalid-feedback d-block blink ">{errors.witnessFirstPhotoSignature}</div>}

                <label className="form-label text-info" htmlFor="txtwitnessFirstFullname" >
                  Witness Fullname <span className="text-danger">(First Middle Last Suffix)</span>
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.witnessFirstFullname && errors.witnessFirstFullname && 'is-invalid'}`}
                  id="txtwitnessFirstFullname"
                  value={formData.witnessFirstFullname}
                  name="attachment_id_number"
                  placeholder="Ex: Juan Mendez dela Cruz Sr."
                  aria-label="witnessFirstFullname"
                  onChange={(e) => setFormData({ ...formData, witnessFirstFullname: e.target.value })}
                />
                {!formData.witnessFirstFullname && errors.witnessFirstFullname && <div className="invalid-feedback d-block blink">{errors.witnessFirstFullname}</div>}
              </div>
            </div>
          </div>

          <div className="col-md-6">

            <div className="card shadow-none border">
              <ImageCapture btnCameraTitle="Open Camera" title="2nd Witness" subtitle="Take a photo of Witness" onImageChange={handleImageChange} keyName="witnessSecondPhoto" preLoadedImage={formData.witnessSecondPhoto} useSignaturePad={true} preLoadedSignature={formData.witnessSecondPhotoSignature} hasUploadButton={false} hasRemoveButton={true} info={"Capture witness and add signature below"} />
            

              <div className="p-4 pt-0 mt-n2">
              {!formData.witnessSecondPhoto && errors.witnessSecondPhoto && <div className="invalid-feedback d-block blink">{errors.witnessSecondPhoto}</div>}
              {!formData.witnessSecondPhotoSignature && errors.witnessSecondPhotoSignature && <div className="invalid-feedback d-block blink">{errors.witnessSecondPhotoSignature}</div>}

                <label className="form-label text-info" htmlFor="txtwitnessSecondFullname" >
                  Witness Fullname <span className="text-danger">(First Middle Last Suffix)</span>
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.witnessSecondFullname && errors.witnessSecondFullname && 'is-invalid'}`}
                  id="txtwitnessSecondFullname"
                  value={formData.witnessSecondFullname}
                  name="attachment_id_number"
                  placeholder="Ex: Juan Mendez dela Cruz Sr."
                  aria-label="witnessSecondFullname"
                  onChange={(e) => setFormData({ ...formData, witnessSecondFullname: e.target.value })}
                />
                {!formData.witnessSecondFullname && errors.witnessSecondFullname && <div className="invalid-feedback d-block blink">{errors.witnessSecondFullname}</div>}
              </div>
            </div>

            

          </div>
        </div>
      </div>



      <div className="row">
        <div className="col-12 d-flex justify-content-between">
          <button className="btn btn-label-secondary btn-prev" onClick={prevPage}>
            <i className="bx bx-chevron-left bx-sm ms-sm-n2" />
            <span className="align-middle d-sm-inline-block d-none">
              Previous
            </span>
          </button>
          <button className="btn btn-primary btn-next" onClick={handleNext}>
            <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
              Next
            </span>
            <i className="bx bx-chevron-right bx-sm me-sm-n2" />
          </button>
        </div>
      </div>


    </div>
  );
};

export default Page2;
